// extracted by mini-css-extract-plugin
module.exports = {"footer":"FooterUtil_footer__1gEDW","credits":"FooterUtil_credits__1A-TW","footer-links":"FooterUtil_footer-links__2bmj9"};